import { AppError } from 'app/common/app-error';

export class NotFoundError extends AppError {}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/common/not-found-error.ts